import {
    GET_ALL_INTERFACES
} from './constants';

const initialState = {
    allInterfaces: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_INTERFACES: {
            return {
                ...state,
                allInterfaces: action.payload,
            };
        }
        default:
            return state;
    }
};

